import type { CompanyUpdateRequest, SupplierSummary } from '../dtos/supplier';

export class Supplier {
  readonly id: number;
  readonly nlsCifno: number;
  readonly companyName: string;
  readonly companyType: 'SUPPLIER' | 'BORROWER';
  readonly status: 'active' | 'suspended';
  readonly phone: string;
  readonly email: string;
  readonly modalUrl: string;
  readonly autocaptureFeature: boolean;

  constructor(params: Partial<Supplier> & { id?: number }) {
    this.id = params.id ?? 0;
    this.nlsCifno = params.nlsCifno ?? 0;
    this.companyName = params.companyName ?? '';
    this.companyType = params.companyType ?? 'SUPPLIER';
    this.status = params.status ?? 'active';
    this.phone = params.phone ?? '';
    this.email = params.email ?? '';
    this.modalUrl = params.modalUrl ?? '';
    this.autocaptureFeature = params.autocaptureFeature ?? false;
  }

  /** Searchable text for table filtering (legacy delimiter avoids partial field matches). */
  filterText(): string {
    const parts = [this.companyName, this.companyType, this.status, this.email, this.phone];
    return parts.join('█').toLowerCase();
  }

  toUpdateRequest(): CompanyUpdateRequest {
    return {
      companyName: this.companyName,
      phone: this.phone || undefined,
      email: this.email || undefined,
      status: this.status,
      modalUrl: this.modalUrl || undefined,
      autocaptureFeature: this.autocaptureFeature,
    };
  }
}

export const SupplierMapper = {
  fromDto(dto: SupplierSummary): Supplier {
    return new Supplier({
      id: dto.id,
      nlsCifno: dto.nlsCifno,
      companyName: dto.companyName,
      companyType: dto.companyType,
      status: dto.status,
      phone: dto.phone,
      email: dto.email,
      modalUrl: dto.modalUrl,
      autocaptureFeature: dto.autocaptureFeature,
    });
  },

  fromDtoList(dtos: SupplierSummary[]): Supplier[] {
    return (dtos ?? []).map((dto) => SupplierMapper.fromDto(dto));
  },
};
